import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleCategories = React.lazy(() => import('./index'));
const ArticleCategoryTable = React.lazy(() => import('./articleCategoryTable'));
const ArticleCategory = React.lazy(() => import('./articleCategory'));
const ArticleCategoryDetail = React.lazy(() => import('./articleCategoryDetail'));
const AddNewArticleCategory = React.lazy(() => import('./addNewArticleCategory'));
const EditArticleCategory = React.lazy(() => import('./editArticleCategory'));

export const useArticleCategoryRoutes = () => {

    return (
        <Route path="articleCategories" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleCategories /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleCategoryTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewArticleCategory/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleCategory/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleCategoryDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditArticleCategory/></Suspense> } />
            </Route>
        </Route>
    )
}